<template>
  <div class="customer-info-section">
    <div class="box">
      <h4 class="title is-4 mb-4">
        <i class="fa fa-user mr-2"></i>
        {{ $t("customer information") }}
      </h4>

      <div class="columns">
        <!-- Customer Details -->
        <div class="column is-4">
          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-user mr-1"></i>
                {{ $t("customer name") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="title is-5">{{ evaluation.customer_name }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-id-card mr-1"></i>
                {{ $t("dpi") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{ evaluation.dpi }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-file-text mr-1"></i>
                {{ $t("pagare number") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{
                    evaluation.pagare_number
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-id-badge mr-1"></i>
                {{ $t("nit") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{ evaluation.nit }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-id-card mr-1"></i>
                {{ $t("segment") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{
                    $t(evaluation.settings?.segment || "unset")
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-file-text mr-1"></i>
                {{ $t("income") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{
                    format_currency(evaluation.settings?.income || 0)
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div
            class="field is-horizontal"
            v-if="evaluation.settings && evaluation.settings.phone_number"
          >
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-phone mr-1"></i>
                {{ $t("phone number") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{
                    evaluation.settings?.phone_number
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div
            class="field is-horizontal"
            v-if="evaluation.settings && evaluation.settings.email"
          >
            <div class="field-label is-small">
              <label class="label">
                <i class="fa fa-envelope mr-1"></i>
                {{ $t("email") }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <span class="tag is-medium">{{
                    evaluation.settings?.email
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Status and Result -->
        <div class="column is-4">
          <div class="field">
            <label class="label">
              <i class="fa fa-flag mr-1"></i>
              {{ $t("evaluation result") }}
            </label>
            <div class="control">
              <div class="tags has-addons are-large">
                <span class="tag is-dark">{{ $t("result") }}</span>
                <span
                  class="tag"
                  :class="getResultClass(evaluation.final_result || 'unset')"
                >
                  {{ $t(evaluation.final_result || "unset") }}
                </span>
              </div>
            </div>
          </div>

          <div class="field" v-if="evaluation.status">
            <label class="label">
              <i class="fa fa-info-circle mr-1"></i>
              {{ $t("status") }}
            </label>
            <div class="control">
              <div class="tags has-addons">
                <span class="tag is-dark">{{ $t("status") }}</span>
                <span class="tag" :class="getStatusClass(evaluation.status)">
                  {{ $t(evaluation.status) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format_currency } from "@/utils";
export default {
  name: "CustomerInfoSection",

  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },

  methods: {
    format_currency,
    /**
     * Get CSS class for evaluation result
     */
    getResultClass(result) {
      const classes = {
        approved: "is-success",
        rejected: "is-danger",
        pending_review: "is-warning",
        unset: "is-dark",
      };
      return classes[result] || classes.unset;
    },

    /**
     * Get CSS class for evaluation status
     */
    getStatusClass(status) {
      const classes = {
        draft: "is-dark",
        completed: "is-success",
        archived: "is-dark",
      };
      return classes[status] || classes.draft;
    },
  },
};
</script>

<style scoped>
.customer-info-section {
  margin-bottom: 1.5rem;
}

.title {
  color: hsl(0, 0%, 96%) !important;
}

.label {
  color: hsl(0, 0%, 96%) !important;
  font-weight: 600;
}

.title.is-5 {
  color: hsl(0, 0%, 96%) !important;
}

.field.is-horizontal .field-label {
  flex-basis: 150px;
  flex-shrink: 0;
}

.tag {
  background-color: hsl(0, 0%, 29%);
  color: hsl(0, 0%, 96%);
  border: 1px solid hsl(0, 0%, 42%);
}

.tag.is-medium {
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
}

.tag.is-dark {
  background-color: hsl(0, 0%, 21%);
  color: hsl(0, 0%, 96%);
}

.tag.is-success {
  background-color: hsl(153, 53%, 53%);
  color: hsl(0, 0%, 21%);
}

.tag.is-danger {
  background-color: hsl(348, 86%, 61%);
  color: hsl(0, 0%, 96%);
}

.tag.is-warning {
  background-color: hsl(44, 100%, 77%);
  color: hsl(0, 0%, 21%);
}

.tags.are-large .tag {
  font-size: 1.1rem;
  padding: 0.6rem 1rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}
</style>
